import * as React from 'react';

const Flag24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M4.75 2a.75.75 0 0 1 .75.75V4h14.75c.616 0 .97.737.586 1.218L17.193 10l3.664 4.808c.353.486-.006 1.192-.607 1.192H5.5v5.25a.75.75 0 0 1-1.5 0V2.75A.75.75 0 0 1 4.75 2m.75 12.5h13.277l-3.134-4.081a.75.75 0 0 1 .021-.91L18.69 5.5H5.5z"
  }
));
Flag24.Size = 24;
Flag24.Title = "Flag";

export { Flag24 as default };
